module.exports = __webpack_public_path__ + "img/4_53.5b2ad8fd.png";